/* eslint-disable jsx-a11y/anchor-is-valid */
import './ChatBubble.css';
import classNames from 'classnames';
import { ESmsRole } from '@leedpulse-monorepo/enums';
import { EditOutlined, RobotOutlined } from '@ant-design/icons';
import { Flex } from 'antd';

interface ChatBubbleProps {
  message: string;
  date: string;
  role: ESmsRole;
  manualSending: boolean;
  actions?: React.ReactNode[];
}

const ChatBubble: React.FC<ChatBubbleProps> = ({
  message,
  date,
  role,
  manualSending,
  actions
}) => {

  return (
    <div
      className={classNames('chat-bubble', {
        'chat-bubble__sent':
          role === ESmsRole.user,
        'chat-bubble__received':
          role === ESmsRole.assistant
      })}
    >
      <p style={{ whiteSpace: "pre-line" }}>{message}</p>
      <div
        style={{
          display: 'flex',
          justifyContent: 'end',
          gap: "10px",
          alignItems: 'center',
        }}
      >
        {actions}
        <span>{date}</span>
        {(role === ESmsRole.system || role === ESmsRole.assistant) && (
          <span
            style={{
              fontSize: '12px',
              fontWeight: manualSending ? 'bold' : '',
              color: manualSending ? 'white' : '',
              opacity: manualSending ? 1 : 0.7,
            }}
          >
            {manualSending ? 
            <Flex align="center"><EditOutlined style={{ marginRight: 6 }} /> Humain</Flex> : 
            <Flex align="center"><RobotOutlined style={{ marginRight: 6 }} /> IA</Flex>}
          </span>
        )}
      </div>
    </div>
  );
};

export default ChatBubble;
